import {EntryPart, QuerySuperEntry} from 'common/query-builder/query-entry-section/types';
import type {QueryEntrySection} from 'common/query-builder/query-entry-section';

import type {ActionHandlers, EntryRow, EntryRowProps} from '../types';

export abstract class BaseEntryRow<EntryType = QuerySuperEntry> implements EntryRow<EntryType> {
  entry: EntryType;
  section: QueryEntrySection;
  index: number;
  template = null;
  actionHandlers: ActionHandlers = null;

  constructor(props: EntryRowProps<EntryType>) {
    this.entry = props.entry;
    this.section = props.section;
    this.index = props.index;
  }

  isPlaceholder() {
    return false;
  }

  isIntermediatePlaceholder() {
    return false;
  }

  selectorIcon(): string | null {
    return null;
  }

  overflowControls() {
    return [];
  }

  defaultActiveEntryPart(): EntryPart | null {
    if (this.isPlaceholder()) {
      return EntryPart.Value;
    }

    return null;
  }
}
